export const categories = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Discover trending footwear from top sellers',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Cozy hoodies and sweaters for every season',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Graphic tees and premium basics',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Stylish outerwear and statement jackets',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'From tailored trousers to casual shorts',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Caps, beanies, and streetwear headwear',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Coordinated outfits and matching sets',
  },
  {
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Essential undergarments and basics',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Sports jerseys and athletic wear',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Watches, jewelry, and finishing touches',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Backpacks, totes, and designer-inspired bags',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Leather belts and statement accessories',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Designer-inspired fragrances and scents',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Everything else worth discovering',
  },
];

export const featuredCategories = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Trending footwear finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20premium%20white%20leather%20sneakers%20with%20minimalist%20design%20placed%20on%20light%20cream%20surface%2C%20soft%20diffused%20natural%20window%20light%20casting%20gentle%20shadows%2C%20clean%20modern%20product%20photography%2C%20neutral%20warm%20beige%20background%2C%20elegant%20lifestyle%20aesthetic%2C%20high%20detail%20material%20texture%20visible&width=800&height=1000&seq=feat-shoes-v8&orientation=portrait',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Cozy & stylish picks',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20single%20oversized%20heavyweight%20beige%20pullover%20hoodie%20neatly%20folded%20on%20light%20oak%20wooden%20surface%2C%20visible%20thick%20cotton%20texture%20and%20ribbed%20cuffs%2C%20soft%20warm%20morning%20sunlight%20from%20side%20window%2C%20minimalist%20cozy%20fashion%20photography%2C%20neutral%20cream%20tones%2C%20peaceful%20aesthetic&width=800&height=1000&seq=feat-hoodies-v8&orientation=portrait',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Graphic & basic tees',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20single%20premium%20heavyweight%20cotton%20white%20t-shirt%20draped%20artistically%20on%20light%20linen%20surface%2C%20visible%20fabric%20weave%20texture%20and%20clean%20stitching%20detail%2C%20soft%20diffused%20natural%20daylight%2C%20minimalist%20fashion%20editorial%20style%2C%20warm%20neutral%20beige%20backdrop%2C%20serene%20aesthetic&width=800&height=1000&seq=feat-tshirts-v8&orientation=portrait',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Statement outerwear',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylish%20olive%20green%20bomber%20jacket%20displayed%20on%20minimalist%20wooden%20hanger%20against%20soft%20cream%20wall%2C%20visible%20satin%20lining%20and%20zipper%20details%2C%20warm%20natural%20studio%20lighting%2C%20clean%20contemporary%20fashion%20photography%2C%20neutral%20earth%20tone%20aesthetic%2C%20refined%20texture&width=800&height=1000&seq=feat-jackets-v8&orientation=portrait',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Watches & jewelry',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20elegant%20minimalist%20silver%20wristwatch%20with%20leather%20strap%20placed%20on%20smooth%20light%20marble%20surface%20next%20to%20a%20delicate%20gold%20chain%20necklace%2C%20soft%20warm%20ambient%20lighting%20from%20above%2C%20luxury%20still%20life%20product%20photography%2C%20neutral%20cream%20background%2C%20refined%20sophisticated%20aesthetic&width=800&height=1000&seq=feat-accessories-v8&orientation=portrait',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Backpacks & totes',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20premium%20tan%20leather%20backpack%20with%20brass%20hardware%20standing%20on%20light%20wooden%20surface%2C%20visible%20stitching%20detail%20and%20textured%20grain%2C%20soft%20natural%20window%20light%20illuminating%20from%20left%20side%2C%20modern%20minimalist%20product%20photography%2C%20warm%20neutral%20backdrop%2C%20timeless%20aesthetic&width=800&height=1000&seq=feat-bags-v8&orientation=portrait',
  },
];